import { render, staticRenderFns } from "./user-investigate.vue?vue&type=template&id=1907ac02&scoped=true&"
import script from "./user-investigate.vue?vue&type=script&lang=js&"
export * from "./user-investigate.vue?vue&type=script&lang=js&"
import style0 from "./user-investigate.scss?vue&type=style&index=0&id=1907ac02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907ac02",
  null
  
)

export default component.exports